import { NgModule } from '@angular/core';
import { Route, RouterModule } from '@angular/router';
import { SettingsLayoutComponent } from './layouts/settings-layout/settings-layout.component';

export const routes: Route[] = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'home',
    loadChildren: () =>
      import('src/app/dashboard-module/dashboard-module-routing.module').then(m => m.routes),
  },
  {
    path: 'search',
    loadChildren: () =>
      import('src/app/search-module/search-module-routing.module').then(m => m.routes),
  },
  {
    path: 'settings',
    component: SettingsLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('src/app/setting-module/setting-module-routing.module').then(m => m.routes),
      },
    ],
  },
  {
    path: 'promotions',
    loadChildren: () =>
      import('src/app/coupon-module/coupon-module-routing.module').then(m => m.promotionRoutes),
  },
  {
    path: 'notification-center',
    title: 'Notification Center',
    loadComponent: () =>
      import('src/app/notification-module/notification-center/notification-center.component').then(
        m => m.NotificationCenterComponent
      ),
  },
  {
    path: 'customers',
    loadChildren: () =>
      import('src/app/customer-module/customer.module').then(m => m.CustomerModule),
  },
  {
    path: 'visitors',
    loadChildren: () =>
      import('src/app/customer-module/customer-module-routing.module').then(m => m.visitors),
  },

  {
    path: 'products',
    loadChildren: () => import('@product/product.module').then(module => module.ProductModule),
  },
  {
    path: 'orders',
    loadChildren: () =>
      import('src/app/order-module/order-module-routing.module').then(m => m.routes),
  },
  {
    path: 'refunds',
    loadChildren: () =>
      import('src/app/order-module/order-module-routing.module').then(c => c.refundRoutes),
  },
  {
    path: 'replacements',
    loadChildren: () =>
      import('src/app/order-module/order-module-routing.module').then(c => c.replacementRoutes),
  },
  {
    path: 'subscriptions',
    loadChildren: () =>
      import('src/app/order-module/order-module-routing.module').then(m => m.subscriptionRoutes),
  },
  {
    path: 'payments',
    loadChildren: () =>
      import('src/app/payment-module/payment-module-routing.module').then(m => m.routes),
  },
  {
    path: 'coupons',
    loadChildren: () =>
      import('src/app/coupon-module/coupon-module-routing.module').then(m => m.routes),
  },
  {
    path: 'segments',
    loadChildren: () =>
      import('src/app/segment-module/segment-module-routing.module').then(m => m.routes),
  },
  {
    path: 'campaigns',
    loadChildren: () =>
      import('src/app/campaign-module/campaign-module-routing.module').then(m => m.routes),
  },
  {
    path: 'loyalty',
    loadChildren: () =>
      import('src/app/loyalty-module/loyalty-module-routing.module').then(m => m.routes),
  },
  {
    path: 'analytics',
    loadChildren: () =>
      import('src/app/analytics-module/analytics-module-routing.module').then(m => m.routes),
  },
  {
    path: 'conversations',
    loadChildren: () => import('./conversation/conversation-routing.module').then(m => m.routes),
  },
  {
    path: 'shipments',
    loadChildren: () =>
      import('src/app/shipment-module/shipment-module-routing.module').then(m => m.routes),
  },
  {
    path: 'media',
    loadChildren: () =>
      import('src/app/media-module/media-module-routing.module').then(m => m.routes),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ModulesRoutingModule {}
